﻿export default class Sticky {

    asideSelector = '[data-js-aside]';
    linkSelector = '[data-js-link]';
    sectionSelector = '[data-js-section]';
    siteHeaderSelector = '[data-js-site-header]';

    activeClass = 'js-active';

    constructor() {
        this.setup();      
    }

    setup = () => {
        const aside = document.querySelector(this.asideSelector);
        const list = document.querySelectorAll(this.linkSelector);
        const headings = document.querySelectorAll("a[id]")

        if (aside) {
            this.handleScrollSpy(list, headings);
        }
    }

    handleScrollSpy = (list, headings) => {
        
        const hero = document.querySelector(this.siteHeaderSelector);
        let heroHeight = hero.offsetHeight;

        // null check to allow hero height checker to catch up
        const makeActive = (link) => {
            if (list[link]) {
                list[link].classList.add(this.activeClass);
            }
        }
        const removeActive = (link) => list[link].classList.remove(this.activeClass);
        const removeAllActive = () => [...Array(headings.length).keys()].forEach((link) => removeActive(link));
        let currentActive = 0;
        const sectionMargin = 100;

        window.addEventListener('scroll', () => {

            // check if scroll has passed hero and the amount of links and sections correspond
            if (window.scrollY > heroHeight && list.length === headings.length) {

                const current = headings.length - [...headings].reverse().findIndex((headings) => window.scrollY >= headings.offsetTop - sectionMargin) - 1;

                if (current !== currentActive) {
                    removeAllActive();
                    currentActive = current;
                    makeActive(current);
                }
            }
        });
    }
}




